export enum StorageKeys
{
    JWT = 'jwt',
    LoginReferrer = 'login-referrer',
    NemIdPid = 'pid',
    NemIdPidLinkedStatus = 'pid-link-status',
    SmtSelectedShares = 'smt.selected.shares',
    UpsaleReservation = 'upsale.reservation',
    ReceiptOrderSmt = 'receipt-order-smt',
    SmtOrderId = 'smt-order-id',
    PendingFmtOrderId = 'pending.fmt.order.id',
    PaymentResponseOrder = 'payment.response.order',
    ReceiptOrderSubscription = 'receipt-order-subscription',
    ShopOrderId = 'shop.order.id',
    NetsContextRoutes = 'nets-context-routes',
    NetsPaymentStatus = 'nets-payment-status',
    NetsPendingPaymentOrderId = 'nets-pending-payment-order-id',
    NetaxeptTransactionRegistrations = 'netaxeptTransactionRegistrations',
    SleetNotesRead = 'sleek-notes-read',
    TrackableOrderId = 'trackable-order-id',
    PaymentPeriod = 'paymentPeriod',
    BasketTicketsCount = 'basket.tickets.count',
    PlayerData = 'playerData',
    GapFundingOrderId = 'gapfunding-order-id',
    GapFundingReturnUrl = 'gapfunding-return-url',
    Paymethod = 'paymethod',
    PaymentMethodUsed = 'paymentMethodUsed',
    GapFundingOrder = 'gapfunding-order',
    PaymentMethodUsedGapfund = 'paymentMethodUsedGapfund',
    LotteryClassId = 'lottery_class_id',
    GapfundDeclined = 'gapfund-declined',
    NewestAddedPaymentMethodId = 'newest-added-payment-method-id',
    TrackingChannel = 'trackingChannel',
    SessionBackup = 'sessionBackup',

}
